import React from "react";
import Item from "./Item";
import NoItem from "./NoItem";
import LoadMore from '../../../components/common/LoadMore';
import ResetSearch from '../../../components/common/ResetSearch'
import { elasticSearchMaxLimit } from '../../../utils/constants'
import "./index.scss";

const AutoPopulateList = ({ searchList, _handleSelectedAction, _handleFilePageChange, _resetSearch, type }) => {
	const tempItem = searchList;

	console.log('tempItem',tempItem)

	return (
		<>
			<div className="auto-populate-blc position-absolute">
				<div className="item-blc overflow-auto">
					{
						tempItem.map((item, i) => {
							return (
								<Item key={i} item={item} __handleSelectedAction={_handleSelectedAction} type={type} />
							)
						})
					}
					{!tempItem.length &&
						<NoItem />
					}
				</div>
				{(
					<div className="btm-blc d-flex">
						{tempItem.length == elasticSearchMaxLimit && <LoadMore page={1} __handlePageChange={_handleFilePageChange} />}
						<ResetSearch label={'Reset'} __resetSearch={_resetSearch} />
					</div>
				)
				}
			</div>
		</>
	);
}

export default AutoPopulateList;